/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { HiOutlineDocumentText, HiOutlinePencil } from "react-icons/hi";

import ListPage from "../../layout/ListPage";
import type { Action, Column } from "../../ui";
import { useStaticContext } from "../../context/StaticContext";
import { pushOneTerms } from "../../lib/sysNavigation/SysNavigation";

type TermsRow = {
  terms_id: number | string;
  description?: string;
  [key: string]: unknown;
};

const editRoute = "/terms/edit";

const stripHtml = (html: string): string => {
  if (typeof document === "undefined") return html.replace(/<[^>]*>/g, " ");
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return (tmp.textContent ?? tmp.innerText ?? "").replace(/\s+/g, " ").trim();
};

const Overview: React.FC = () => {
  const navigate = useNavigate();
  const { terms, fetchTerms } = useStaticContext() as any;

  useEffect(() => {
    if (!terms) fetchTerms();
  }, [terms]);

  const rows = useMemo<TermsRow[] | null>(() => {
    if (!Array.isArray(terms)) return null;
    return terms as TermsRow[];
  }, [terms]);

  const columns: Column<TermsRow>[] = [
    {
      header: "Preview",
      cell: (row) => {
        const text = row.description ? stripHtml(row.description) : "";
        return text ? (
          <p className="line-clamp-3 text-gray-700">{text}</p>
        ) : (
          <span className="text-gray-400">No content yet.</span>
        );
      },
    },
  ];

  const rowActions = (row: TermsRow): Action[] => [
    {
      label: "Edit",
      icon: <HiOutlinePencil className="h-3.5 w-3.5" />,
      onClick: () => {
        pushOneTerms(row);
        navigate(editRoute);
      },
    },
  ];

  return (
    <ListPage<TermsRow>
      title="Terms & Conditions"
      subtitle="Sections of the public Terms & Conditions page."
      icon={<HiOutlineDocumentText className="h-5 w-5" />}
      rows={rows}
      columns={columns}
      rowKey={(r) => r.terms_id}
      rowActions={rowActions}
      empty="No terms sections yet."
    />
  );
};

export default Overview;
